export default __webpack_public_path__ + "static/media/6OctoberLogo.aac66552.svg";